module.exports = __webpack_public_path__ + "static/media/ecommerce-hero.7f5eb67b.png";